import Vue from 'vue'
//自动关闭弹框
import ClosedProp2 from '@/components/promptbox/ClosedProp2.vue'
//确认框
import ConfirmProp2 from '@/components/promptbox/ConfirmProp2.vue'
//警告确认框
import ConfirmWarningProp2 from '@/components/promptbox/ConfirmWarningProp2.vue'
//成功提示框
import SuccessProp2 from '@/components/promptbox/SuccessProp2.vue'
//操作提醒框
import ToolTipProp2 from '@/components/promptbox/ToolTipProp2.vue'
//文件报告中
 import ReportLoading from '@/components/promptbox/ReportLoading.vue'
 //加载数据中
 import LoadingProp from '@/components/promptbox/LoadingProp.vue'
 //警告
 import WarningProp from '@/components/promptbox/WarningProp.vue'
// 添加install方法
const promptbox ={
	install:function(Vue) {
	  Vue.component(ClosedProp2.name, ClosedProp2);
	  Vue.component(ConfirmProp2.name, ConfirmProp2);
	  Vue.component(ConfirmWarningProp2.name, ConfirmWarningProp2);
	  Vue.component(SuccessProp2.name, SuccessProp2);
	  Vue.component(ToolTipProp2.name, ToolTipProp2);
	  Vue.component(ReportLoading.name, ReportLoading);
	   Vue.component(LoadingProp.name, LoadingProp);
	    Vue.component(WarningProp.name, WarningProp);
	}
}

export default promptbox;